import { render } from "./BCalendar.vue?vue&type=template&id=5c748ac9"
import script from "./BCalendar.vue?vue&type=script&lang=js"
export * from "./BCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__